// extracted by mini-css-extract-plugin
module.exports = {"scaleDesc":"styles_scaleDesc__IhL97"};